import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-results-zero-view',
  templateUrl: './results-zero-view.component.html',
  styleUrls: ['./results-zero-view.component.css']
})
export class ResultsZeroViewComponent implements OnInit {

  @Input() queryString?: string | null;
  @Input() routeLink: string = '';
  
  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  goSearch() {
    this.router.navigate(['adv-search']);
  }
}
